import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const brokerTypes = createTypes([
        'REQUEST',
        'RECEIVE',
        'ERROR',
        'SUCCESS',
        'REQUEST_ADMIN',
        'RECEIVE_ADMIN',
        'ERROR_ADMIN',
    ], 'BROKERS');


export const requestBrokerInfo = () => {
    return {
        type: brokerTypes.REQUEST,
    };
};

export const receiveBrokerInfo = (response) => {
    return {
        type: brokerTypes.RECEIVE,
        data: response,
    };
};

export const receiveBrokerInfoError = (response) => {
    return {
        type: brokerTypes.ERROR,
        error: response,
    };
};

export const isUserBroker = () => {
    return dispatch => {
        let apiUrl = `api/v1/customer/isuserbroker`

        dispatch(requestBrokerInfo());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveBrokerInfo(response));
            } catch (e) {
                dispatch(receiveBrokerInfoError(response));
            }
        })
        .catch(handleNetworkError);
    };
};

export const requestAdminInfo = () => {
    return {
        type: brokerTypes.REQUEST_ADMIN,
    };
};

export const receiveAdminInfo = (response) => {
    return {
        type: brokerTypes.RECEIVE_ADMIN,
        data: response,
    };
};

export const receiveAdminInfoError = (response) => {
    return {
        type: brokerTypes.ERROR_ADMIN,
        error: response,
    };
};

export const isUserAdmin = () => {
    return dispatch => {
        let apiUrl = `api/v1/customer/isuseradmin`

        dispatch(requestAdminInfo());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveAdminInfo(response));
            } catch (e) {
                dispatch(receiveAdminInfoError(response));
            }
        })
        .catch(handleNetworkError);
    };
};